import React, { useRef, useEffect, useState } from 'react'
import {
    Box,
    Typography,
    Skeleton,
    Card
} from '@mui/material'
import { Image, Carousel } from 'antd'
import IconLeft from '../../../assets/home/icon_left.png'
import IconRight from '../../../assets/home/icon_right.png'
import axios from 'axios'
import { NewsUrl } from '../../../common/url'
import { ROOT_PATH, App_Language_key } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppHomeWhatsNew: React.FC = () => {
    const { t } = useTranslation()

    const [data, setData] = useState([])

    const carouselRef = useRef(null)

    const next = () => {
        carouselRef.current.next()
    }

    const prev = () => {
        carouselRef.current.prev()
    }

    const language = sessionStorage.getItem(App_Language_key) === 'ms' ? 'BM' : 'EN'
    
    const fetchList = async () => {
        try {
            const response = await axios.get(NewsUrl + '?pagination[page]=1&pagination[pageSize]=6&sort=sequence:ASC&publicationState=live&filters[language][$eq]='+ language)
            var list = response.data['data']
            setData(list.length > 6 ? list.slice(0, 6) : list)
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const detail = (id: number) => {
        window.open(ROOT_PATH + '/news-detail?id=' + id)
    }

    const renderCarouselItem = (index: number) => {
        return (
            <Box key={index}
                onClick={() => detail(data[index]['id'])}
                sx={{
                    width: '100%',
                    height: '100%',
                    borderRadius: 6,
                }}>
                <Card
                    style={{
                        borderRadius: '4px',
                        boxShadow: 'none',
                        border: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: data[index]['attributes']['image']}} />
                </Card>
                <Typography fontWeight={400} fontSize={'12px'} color={'#6B6B6B'} sx={{
                    paddingTop: '20px'
                }}>
                    {data[index]['attributes']['Description']}
                </Typography>
                <Typography fontWeight={600} fontSize={'18px'} color={'#141F39'} sx={{
                    paddingTop: '12px'
                }}>
                    {data[index]['attributes']['title']}
                </Typography>
                <Typography fontWeight={500} fontSize={'16px'} color={'#6B6B6B'} sx={{
                    paddingTop: '6px'
                }}>
                    {t('t76')}
                </Typography>
            </Box>
        )
    }

    const skeletonCard = (index: number) => {
        return (
            <Box sx={{
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '30px'
            }}>
                <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'100%'} height={'260px'} style={{ borderRadius: '4px' }} ></Skeleton>
                <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'80%'} height={'22px'} style={{ marginTop: '26px', borderRadius: '4px' }}></Skeleton>
                <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'60%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
                <Skeleton variant={'rect'} paragraph={{ rows: 1 }} animation={'wave'} width={'40%'} height={'16px'} style={{ marginTop: '16px', borderRadius: '4px' }}></Skeleton>
            </Box>
        )
    }

    const carouselBodyItem = () => {
        return (
            <Box sx={{
                width: '100%',
                position: 'relative',
                paddingTop: '15px',
            }}>

                <Carousel dots={false} ref={carouselRef} style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}>
                    {data.map((item, index) => (
                        renderCarouselItem(index)
                    ))}
                </Carousel>

                <Box sx={{ position: 'absolute', top: '30%', bottom: '70%', left: '4px' }}>
                    <Box onClick={() => prev()} sx={{ width: '48px', height: '48px', backgroundColor: 'rgba(0, 0, 0, 0.3)', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', borderRadius: '24px', cursor: 'pointer' }}>
                        <Image src={IconLeft} width={26} height={26} alt='' preview={false}></Image>
                    </Box>
                </Box>

                <Box sx={{ position: 'absolute', top: '30%', bottom: '70%', right: '4px' }}>
                    <Box onClick={() => next()} sx={{ width: '48px', height: '48px', backgroundColor: 'rgba(0, 0, 0, 0.3)', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center', borderRadius: '24px', cursor: 'pointer' }}>
                        <Image src={IconRight} width={26} height={26} alt='' preview={false}></Image>
                    </Box>
                </Box>
            </Box>
        )
    }


    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            paddingTop: '30px',
            paddingBottom: '30px',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontWeight={700} fontSize={'24px'} color={'#141F39'} textAlign={'left'}>
                    {t('t75')}
                </Typography>
            </Box>

            {data === null || data.length === 0 ? skeletonCard() : carouselBodyItem()}
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeWhatsNew
